export enum SuperAdminNavigations {
    SUPER_ADMIN_DASHBOARD = "/super-admin/dashboard",
    SUPER_ADMIN_SIGNIN='/super-admin/sign-in',
    SUPER_ADMIN_DASHBOARD_ORG='/super-admin/dashboard/organisation',
    SUPER_ADMIN_COMING_SOON='/super-admin/dashboard/coming-soon',
    VIEW_EDIT_ORGANISATION_DETAILS='/super-admin/organisation-details',
    ORGANISATION_DETAILS_PROFILE='/super-admin/organisation-details/profile',
    ORGANISATION_DETAILS_USER='/super-admin/organisation-details/users',
    ORGANISATION_DETAILS_REPORTS='/super-admin/organisation-details/reports',
    ORGANISATION_DETAILS_SETTINGS='/super-admin/organisation-details/settings',
    ORG_CREATE_USER='/super-admin/add-edit-user',
    SUPER_ADMIN_CREATE_ORG='/super-admin/create-org',
    SUPER_ADMIN_DASHBOARD_PERMISSIONS='/super-admin/dashboard/permissions',
}